import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
const state = {
  // 加油枪号
  rules: {},
  hasId: ''
}
export default {
  getters,
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/stores/rules/index.js